import React, { useEffect, useState } from "react"
import PropertyCard from "../../component/PropertyCard"
import { Typography } from "@material-tailwind/react"
import { getListing } from "../../../service/ListingService"
import { useNavigate } from "react-router"
import { WBLabel } from "../../component/WBLabel"
import { currencyFormat } from "../../../helper/numberHelper"

function ListingMain ({

}) {
    const navigate = useNavigate()
    const [ data, setData ] = useState([])

    useEffect(() => {
        loadProperties()
    }, [])

    const loadProperties = async () => {
        const { data, error } = await getListing({
            limit: 5
        });
        setData(data)
    }

    return (
        <section className="px-0">
            {
                (data && data.length > 0) &&
                <div className="md:flex">
                    {/* <div className="text-center w-[100%] md:w-[20%] md:mr-4 md:text-left md:self-center"> */}
                    <div className="text-center w-[100%] md:w-[20%] md:mr-4 md:text-left">
                        <WBLabel bold className="text-[30px] font-bold" text={"Baru di update"}/>
                        <WBLabel
                            size={18}
                            className="!text-gray font-semibold sm:text-lg"
                            text={"Temukan properti baru dari Maxx Property"}
                        />
                    </div>
                    <div className="p-2 pt-10 -mr-12 mt-6 md:mt-0 w-full overflow-y-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
                        <div className={`flex flex-row items-center justify-around space-x-6`}>
                        {
                            data.map( (v, index) => {
                                return (
                                    <section key={v._id} className="w-[100%] md:w-[2/5] lg:w-[3/5] md:max-w-[300px] flex-shrink-0">
                                        <PropertyCard 
                                            id={v._id}
                                            data={v}
                                            imgs={v.propertyImages}
                                            tag={`#${v.listingId}`}
                                            // title={v.name}
                                            title={currencyFormat(v.price)}
                                            desc={v.name} 
                                            date={v.createdDate}
                                            label={"Detail"}
                                            agent={v.agent}
                                            onClick={() => {
                                                navigate(`/listing/${v._id}`)
                                            }}
                                        />
                                    </section>
                                )
                            })
                        }
                        </div>
                    </div>
                </div>
            }
        </section>
    )
}

export default ListingMain